import Homepage from "@/Pages/AcessoResponsavel/HomePage.vue";

export default [
  {
    path: "/acesso-responsavel/home",
    name: "acessoResponsavel.home",
    component: Homepage,
  },
];
